var _classCallCheck = require("/usr/local/jenkins/workspace/helpdoc_open/helpdoc_open/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var FetchData = function FetchData(url, opt) {
  "use strict";

  var _this = this;
  _classCallCheck(this, FetchData);
  var options = {};
  var fetchUrl;
  if (typeof url === 'string') {
    fetchUrl = url;
    if (opt && typeof opt === 'object') {
      options = opt;
    }
  } else if (typeof url === 'object') {
    options = url;
    fetchUrl = String(options.url);
  }

  // 默认参数
  var defaultOptions = {
    method: 'GET',
    // 默认为 GET 方式
    credentials: 'include',
    // 默认带上 cookie
    headers: {
      'Content-Type': 'application/json',
      // 默认为 json 格式
      'X-Requested-With': 'XMLHttpRequest' // 增加 X-Requested-With 请求头用于服务端判断是否为 xhr 请求
    }
  };
  // 如果有本地有 lang 参数，则添加到请求头
  if (window.localStorage && window.localStorage.getItem('lang')) {
    defaultOptions.headers.lang = window.localStorage.getItem('lang');
  }
  // 新配置
  var newOptions = Object.assign({}, defaultOptions, options);
  newOptions.headers = Object.assign({}, defaultOptions.headers, options.headers);
  newOptions.method = String(newOptions.method).toUpperCase();
  var method = newOptions.method,
    body = newOptions.body,
    query = newOptions.query,
    metaHandler = newOptions.metaHandler; // GET/DELETE/HEAD请求将body参数放到url中
  if (method === 'GET' || method === 'DELETE' || method === 'HEAD') {
    var bodyParams = [];
    // GET请求增加随机参数 _r 从而禁止浏览器缓存
    if (method === 'GET') {
      bodyParams.push('_r=' + Math.random());
    }
    if (body && typeof body === 'object') {
      Object.keys(body).forEach(function (key) {
        bodyParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(body[key]));
      });
      delete newOptions.body;
    }
    if (bodyParams.length > 0) {
      if (fetchUrl.indexOf('?') !== -1) {
        fetchUrl += '&' + bodyParams.join('&');
      } else {
        fetchUrl += '?' + bodyParams.join('&');
      }
    }
  } else if (body instanceof FormData) {
    delete newOptions.headers['Content-Type'];
    newOptions.body = body;
  } else if (newOptions.headers['Content-Type'] === 'application/json' && body) {
    newOptions.body = JSON.stringify(body);
  } else if (newOptions.headers['Content-Type'] === 'application/x-www-form-urlencoded' && body) {
    // form-urlencoded 参数处理
    var _bodyParams = [];
    if (body && typeof body === 'object') {
      Object.keys(body).forEach(function (key) {
        _bodyParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(body[key]));
      });
      newOptions.body = _bodyParams.join('&');
    }
  }

  // 如果有query参数 放到url中
  if (query && typeof query === 'object') {
    var queryParams = [];
    Object.keys(query).forEach(function (key) {
      queryParams.push(key + '=' + query[key]);
    });
    if (fetchUrl.indexOf('?') !== -1) {
      fetchUrl += '&' + queryParams.join('&');
    } else {
      fetchUrl += '?' + queryParams.join('&');
    }
    delete newOptions.query;
  }
  this.fetchUrl = fetchUrl;
  this.options = newOptions;

  // 判断执行 beforeRequest 方法
  if (typeof FetchData.beforeRequest === 'function') {
    FetchData.beforeRequest(this);
  }
  var promise = new Promise(function (resolve, reject) {
    fetch(fetchUrl, newOptions).then(function (response) {
      var contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json();
      } else {
        return response.text();
      }
    }).then(function (data) {
      _this.res = data;
      // 如果有配置 metaHandler 参数，则判断执行
      if (metaHandler) {
        if (data && data.meta && data.meta.code && typeof metaHandler[data.meta.code] === 'function') {
          if (metaHandler[data.meta.code]()) {
            resolve(data);
          } else {
            reject(data);
          }
        }
      }

      // 如果有 filter 方法，则判断执行
      if (typeof FetchData.filter === 'function') {
        if (FetchData.filter.call(_this, data, _this)) {
          resolve(data);
        } else {
          reject(data);
        }
      }
      resolve(data);
    }).catch(function (err) {
      _this.res = err;
      reject(err);
    });
  });
  return promise;
};
(function (window, factory) {
  if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    window.FetchData = factory();
  }
})(this, function () {
  return FetchData;
});